import { useMemo } from "react";

import { isLensTeamPlan } from "src/services/plans";

import { useGetBusinessSubscriptions } from "./useGetBusinessSubscriptions";
import { useBooleanFlagValue } from "@openfeature/react-sdk";
import { getCurrentSubscription } from "src/services/getCurrentSubscription";
import { getSubscriptionPlanMetaData } from "src/services/getSubscriptionPlanCode";

export const useGetCurrentBusinessPlan = (businessId?: string) => {
  const { businessSubscriptions, loading, reload } = useGetBusinessSubscriptions(businessId);

  const lensTeamLicenseFlag = useBooleanFlagValue("lens-team-license", false);

  const subscription = useMemo(() => {
    if (loading || !businessSubscriptions) {
      return undefined;
    }

    return getCurrentSubscription(businessSubscriptions);
  }, [businessSubscriptions, loading]);

  const plan = useMemo(() => {
    if (loading) {
      return undefined;
    }

    return getSubscriptionPlanMetaData(subscription, lensTeamLicenseFlag);
  }, [loading, subscription, lensTeamLicenseFlag]);

  const isTeamPlan = useMemo(() => {
    return isLensTeamPlan(plan?.type);
  }, [plan?.type]);

  return {
    subscription,
    plan,
    isTeamPlan,
    loading,
    reload,
  };
};
